import { render } from "./Itinerario.vue?vue&type=template&id=631a05f6&scoped=true"
import script from "./Itinerario.vue?vue&type=script&lang=js"
export * from "./Itinerario.vue?vue&type=script&lang=js"

import "./Itinerario.vue?vue&type=style&index=0&id=631a05f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sisco\\Documents\\logistica\\AppChoferes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631a05f6"]])

export default __exports__